import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import { isIterableArray } from "../../helpers/utils";

export default function SelectVariants({
  type = "product.choice-of-product",
  data,
  variants = null,
  changeHandler,
  deleteHandler,
  index,
}) {
  const [reqArr, setReqArr] = useState([]);
  const [selctedValue, setSelctedValue] = useState("");

  const handleSelectChange = (label, value, id, variants, index) => {
    if(value){
      changeHandler(label, value, id, variants, index)
    setSelctedValue(value)
    }
  }

  const handleDeleteItem = (index) => {
    deleteHandler(index)
    setSelctedValue("")
  }

  return (
    <>
      <span className="selected-items">{data.product?.title}</span>
      {data &&
        data.product &&
        data.product?.ProductVariant &&
        isIterableArray(data.product?.ProductVariant) &&
        data.product?.ProductVariant[0] &&
        data.product?.ProductVariant[0] &&
        data.product?.ProductVariant[0].Variants &&
        isIterableArray(data.product?.ProductVariant[0].Variants) && (
          <>
            <div className="form-control-wrapper">
              <Form.Control
                as="select"
                aria-label="Choose an option"
                name="Choose an option"
                onChange={(event) => {
                  handleSelectChange(
                    data.product?.ProductVariant[0].label,
                    event.target.value,
                    variants ? null : data.product.id,
                    variants ? variants : null,
                    index
                  );
                }}
                defaultValue="Choose an option"
                value={selctedValue}
                required
              >
                <option value="">Choose a option</option>
                {variants
                  ? variants.map((data: any, i: number) => {
                      return (
                        <option key={i} value={data.value}>
                          {data.value}
                        </option>
                      );
                    })
                  : data.product?.ProductVariant[0].Variants.map(
                      (data: any, i: number) => {
                        return (
                          <option key={i} value={data.value}>
                            {data.value}
                          </option>
                        );
                      }
                    )}
              </Form.Control>
              <p className={`clear-select ${selctedValue ? `clear-select-enabled` : `clear-select-disabled`}`} onClick={() => handleDeleteItem(index)}>Clear</p>
            </div>
          </>
        )}
    </>
  );
}
